export const Continue = {
  print: () => 'continue'
};
